import React from 'react';
import PropTypes from 'prop-types';
import { DropDownBtn } from '../elements-dropdown/dropdown-btn-v2';
import { List } from '../elements-dropdown/dropdown-list-v2';
import { FormattedMessage } from 'react-intl';

const ListingInfo = ({ listings = {}, show, hideArrow, data: id, isMobile, index }) => {
  const { title = '', use_type, is_instant_book_active: instantBookActive } = listings[id] || {};
  if (isMobile) {
    return (
      <option
        key={`listings-key-${index}`}
        value={id}
        data-value={id}
      >
        { title }
      </option>
    );
  }
  return (
    <ul
      key={`listings-key-${index}`}
      className="list-inline"
    >
      <li className="v-center button-text">
        { instantBookActive ?
          <div className="pull-right">
            <span className="green-dot" />
            <span className="on-label">
              <FormattedMessage
                id="hosting.listing_selector.on"
                defaultMessage="on"
              />
            </span>
          </div> : null }
        <div className="ellipsis list-title">{title}</div>
        <div className="text-gray ellipsis">{use_type}</div>
      </li>
      {
        hideArrow ?
          null :
          <li className="v-center button-arrow">
            <div className={`custom-arrow ${show ? 'up' : 'down'}`} />
          </li>
      }
    </ul>
  );
};

export class ListingSelector extends React.Component {
  render () {
    const {
      listingClickFn,
      listings,
      selectedListingId,
      inputRef,
      buttonClass
    } = this.props;
    const listingIds = Object.keys(listings);
    return (
      <DropDownBtn
        buttonClassName={`no-btn-outline space-dropdown-button ${buttonClass}`}
        buttonChildren={
          <div
            ref={
              ref => {
                if (inputRef) inputRef(ref);
                this.listingRef = ref;
                return this.listingRef;
              }
            }
            data-value={selectedListingId}
          >
            <ListingInfo
              data={selectedListingId}
              listings={listings}
            />
          </div>
        }
      >
        <List
          listKey="space-listings"
          listClick={listingClickFn}
          listData={listingIds}
          listClassName="listings-list"
          selectedValue={selectedListingId}
        >
          <ListingInfo
            hideArrow
            listings={listings}
          />
        </List>
      </DropDownBtn>
    );
  }
}

ListingSelector.propTypes = {
  listingClickFn: PropTypes.func,
  listings: PropTypes.object,
  selectedListingId: PropTypes.string,
  inputRef: PropTypes.func,
  buttonClass: PropTypes.string
};

ListingInfo.propTypes = {
  data: PropTypes.string,
  show: PropTypes.bool,
  listings: PropTypes.object,
  hideArrow: PropTypes.bool,
  isMobile: PropTypes.bool,
  index: PropTypes.string
};
